import { useLocation } from 'react-router-dom'
import { useT } from '../i18n'
import { useTheme, type Theme } from '../theme'
// CSS Module — only contains the fixed-position container. The
// ``.glass-pill`` visual primitive stays global (see
// ``styles/glass-pill.css``). #264 PR C.
import s from './ThemeSwitcher.module.css'

export default function ThemeSwitcher() {
  const { theme, setTheme } = useTheme()
  const t = useT()
  const location = useLocation()

  // Splash hardcodes a violet gradient regardless of theme, so we
  // flip to the white-text glass variant there to match the splash
  // button + bubble aesthetic.
  const isSplash =
    location.pathname === '/' || location.pathname === '/en'

  return (
    <select
      value={theme}
      onChange={(e) => setTheme(e.target.value as Theme)}
      aria-label="Theme"
      className={[
        s.themeSwitcher,
        'glass-pill',
        isSplash && 'glass-pill--on-dark',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <option value="light">{t('theme.light')}</option>
      <option value="dark">{t('theme.dark')}</option>
      <option value="colorful">{t('theme.colorful')}</option>
    </select>
  )
}
